import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={29}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M18.317 10.531 8.51 20.883a1.05 1.05 0 0 1-.788.349c-.304 0-.567-.117-.787-.35a1.163 1.163 0 0 1-.331-.829c0-.32.11-.596.331-.828L16.77 8.903H8.373c-.314 0-.576-.112-.788-.335a1.152 1.152 0 0 1-.317-.828c0-.33.106-.606.318-.83.212-.223.474-.334.787-.333h11.049c.313 0 .575.111.788.335.212.223.317.499.317.828v11.63c0 .33-.106.607-.318.83a1.038 1.038 0 0 1-.787.334c-.313 0-.576-.112-.788-.335a1.153 1.153 0 0 1-.317-.828v-8.84Z"
    />
  </svg>
)
export default SvgComponent
